function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Toggle } from '../../../../../../../components/ui/toggle';
import classes from './shipping.scss';
const toggleClasses = {
  faceClassName: classes.toggleFace,
  labelClassName: classes.toggleLabel,
  toggleClassName: classes.toggleToggle,
  wrapperClassName: classes.toggleWrapper,
  checkLabelClassName: classes.toggleCheckLabel
};
export const ShippingFilterComponent = ({
  color = '',
  isInternationalShippingSelected,
  onInternationalShippingChange
}) => {
  const onToggle = () => {
    onInternationalShippingChange(!isInternationalShippingSelected);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(Toggle, _extends({}, toggleClasses, {
    color: color,
    toggleClassName: classes.toggleToggle,
    value: !!isInternationalShippingSelected,
    onToggle: onToggle,
    uncheckedLabel: "Only show products that can be shipped outside of the United States"
  })));
};